import { render, staticRenderFns } from "./FormHealthSecurity.vue?vue&type=template&id=b89569ba&scoped=true&"
import script from "./FormHealthSecurity.vue?vue&type=script&lang=js&"
export * from "./FormHealthSecurity.vue?vue&type=script&lang=js&"
import style0 from "./FormHealthSecurity.vue?vue&type=style&index=0&id=b89569ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89569ba",
  null
  
)

export default component.exports